import React, {useState} from 'react';
import styled from 'styled-components';
import {Button} from '@betareader/design-system';
import {useTranslation} from 'react-i18next';

const Row = styled.li`
  border-bottom: 1px solid var(--br-border);
  display: grid;
  gap: var(--br-space-2);
  padding: var(--br-space-3) 0;
`;

const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--br-space-2);
`;

const Select = styled.select`
  background: var(--br-surface);
  border: 1px solid var(--br-border);
  border-radius: var(--br-control-radius);
  color: var(--br-text);
  min-height: 40px;
  padding: 0 var(--br-space-2);
`;

const Choices = styled.div`
  display: grid;
  gap: var(--br-space-1);
  max-height: 200px;
  overflow: auto;
`;

const ReaderFilter = ({index, operator, value = [], removeFilter, addFilter,
  readerOptions = [], handleFilterChange}) => {
  const {t} = useTranslation();
  const [search, setSearch] = useState('');
  const selected = Array.isArray(value) ? value : [];
  const currentOperator = operator || '$in';
  const visibleOptions = readerOptions.filter(option =>
    option.text?.toLocaleLowerCase().includes(search.toLocaleLowerCase())
  );

  const changeValue = (readerId, checked) => {
    const next = checked
      ? [...new Set([...selected, readerId])]
      : selected.filter(value => value !== readerId);
    handleFilterChange({operator: currentOperator, value: next, index});
  };

  return (
    <Row>
      <label htmlFor={`report-reader-operator-${index}`}>{t('FilterOperator')}</label>
      <Select id={`report-reader-operator-${index}`} value={currentOperator}
        onChange={event => handleFilterChange({operator: event.target.value, value: selected, index})}>
        <option value='$in'>{t('Include')}</option>
        <option value='$nin'>{t('Exclude')}</option>
      </Select>
      <label htmlFor={`report-reader-search-${index}`}>{t('Readers')}</label>
      <input id={`report-reader-search-${index}`} type='search' value={search}
        onChange={event => setSearch(event.target.value)} />
      <Choices role='group' aria-label={t('Readers')}>
        {visibleOptions.map(option => (
          <label key={option.value}>
            <input type='checkbox' checked={selected.includes(option.value)}
              onChange={event => changeValue(option.value, event.target.checked)} />
            {option.text} {option.description && <small>({option.description})</small>}
          </label>
        ))}
      </Choices>
      <Controls>
        <Button variant='secondary' size='small' onClick={() => removeFilter(index)}>{t('RemoveFilter')}</Button>
        <Button variant='secondary' size='small' onClick={() => addFilter(index)}>{t('AddFilter')}</Button>
      </Controls>
    </Row>
  );
};

export default ReaderFilter;
